import React, {useRef} from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import PaymentReportSearch from '@components/payments/gateways/Search';
import PaymentsTypesReport from './TypesPage';
import PaymentsGatewaysReport from './GatewaysPage';


function PaymentsReportTypesPage() {
  const gatewaysReportRef = useRef();
  const typesReportRef = useRef();
  
  const search = (searchParams) => {
    gatewaysReportRef.current.search(searchParams)
    typesReportRef.current.search(searchParams)
  };
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <PaymentReportSearch search={search}/>
        </Card>
      </Col>
      <Col span={12}>
        <PaymentsTypesReport innerRef={typesReportRef}/>
      </Col>
      
      <Col span={12}>
        <PaymentsGatewaysReport innerRef={gatewaysReportRef}/>
      </Col>
    </Row>
  )
}

export default PaymentsReportTypesPage;



